import Itinerary from '@/models/Itinerary'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    fetchingList: false,
    itineraryDetails: {
      name: '',
      local_information: '',
      retail_ids: [],
      routes: {
        name: '',
        description: '',
        image: null
      },
      accommodation_ids: [],
      stop_ids: [''],
      playlists: []
    },
    itineraryLocation: null
  },

  mutations: {
    setFetchingList(state, status) {
      state.fetchingList = status
    },

    setItineraryList(state, itineraries) {
      each(itineraries, itinerary => {
        const exist = find(state.list, {
          id: itinerary.itinerary_activity_template_id
        })
        if (!exist) {
          state.list.push(new Itinerary(itinerary))
        }
      })
    },

    clearItineraryList(state) {
      state.list = []
    },

    setItineraryListMeta(state, meta) {
      state.listMeta = meta
    },

    setItineraryDetails(state, itinerary) {
      if (itinerary instanceof Itinerary) {
        state.itineraryDetails = itinerary
      } else {
        state.itineraryDetails = new Itinerary(itinerary)
      }
    },

    clearItineraryDetails(state) {
      state.itineraryDetails = {
        name: '',
        local_information: '',
        retail_ids: [],
        routes: {
          name: '',
          description: '',
          image: null
        },
        accommodation_ids: [],
        stop_ids: [''],
        playlists: []
      }
    }
  },

  actions: {
    clearItineraryDetails({ commit }) {
      commit('clearItineraryDetails')
    },

    async createItinerary({ commit }, formData) {
      const { data } = await Api.post(`admin/template`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      commit('setItineraryDetails', data.data)
    },

    async updateItinerary({ commit }, formData) {
      const { data } = await Api.post(
        `admin/template/${formData.get('itinerary_activity_template_id')}`,
        formData
      )
      commit('setItineraryDetails', data.data)
    },

    async deleteItinerary({ commit }, itineraryId) {
      const { data } = await Api.delete(`admin/template/${itineraryId}`)
      commit('setItineraryDetails', data.data)
    },

    async getItineraries({ commit }, params) {
      const query = Itinerary.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      commit('setFetchingList', true)
      const res = await query
        .params({ limit: 20 })
        .get()
        .finally(() => {
          commit('setFetchingList', false)
        })

      commit('setItineraryList', res.data)
      commit('setItineraryListMeta', res.meta)
    },

    async getAllItineraries({ commit }) {
      commit('setFetchingList', true)
      const { data } = await Api.get(`admin/template?all=true`).finally(() => {
        commit('setFetchingList', false)
      })
      commit('setItineraryList', data.data)

      return data
    },

    async getItineraryDetails({ commit }, id) {
      const { data } = await Api.get(`admin/template/${id}`)
      commit('setItineraryDetails', data.data)

      return data
    }
  }
}
